<script lang="ts">
  import { tracePoints } from './board-trace';

  /** The traced word's line over a board; the theme's path animation runs once two tiles join. */
  let { path, size }: { path: readonly number[]; size: number } = $props();
</script>

<svg class="trace-path" class:tracing={path.length > 1} viewBox="0 0 100 100" aria-hidden="true">
  <polyline points={tracePoints(path, size)} />
</svg>
